const data = [
    { id: 1, name: "Majoração" },
    { id: 2, name: "Minoração" },
    { id: 3, name: "Reclassificação" },
    { id: 4, name: "Exclusão" }
  ];
  
  export default [...data];